import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { KillBattleOutcome } from "@/types/KillBattleOutcome";

export interface KillOutcomeState {
  currentBattle: KillBattleOutcome | null;
  isClaimingReward: boolean;
}

const initialState: KillOutcomeState = {
  currentBattle: null,
  isClaimingReward: false,
};

const killOutcomeSlice = createSlice({
  name: "killOutcome",
  initialState,
  reducers: {
    setKillBattleOutcome: (state, action: PayloadAction<KillBattleOutcome>) => {
      state.currentBattle = action.payload;
    },
    markKillRewardsClaimed: (state) => {
      if (state.currentBattle) {
        state.currentBattle.rewardsClaimed = true;
      }
    },
    clearKillBattleOutcome: (state) => {
      state.currentBattle = null;
      state.isClaimingReward = false;
    },
    setKillOutcomeClaiming: (state, action: PayloadAction<boolean>) => {
      state.isClaimingReward = action.payload;
    },
  },
});

export const {
  setKillBattleOutcome,
  markKillRewardsClaimed,
  clearKillBattleOutcome,
  setKillOutcomeClaiming,
} = killOutcomeSlice.actions;

export default killOutcomeSlice.reducer;
